'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _label = require('./label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _label2.default; /**
                                    * Created by yjcxy12 on 16/1/22.
                                    */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/label/index.js
// module id = 1861
// module chunks = 5